<template>
  <div>
    <div class="columns">
      <div class="column" style="position: relative; height: 50px">
        <div class="columns">
          <div class="column is-11">
            <div class="columns is-mobile">
              <div class="column">
                <b-tooltip
                  type="is-dark"
                  position="is-right"
                  :label="$translate('copy_dx_in_sx') | capitalize"
                  multilined
                >
                  <a class="button is-primary" :disabled="disabledbool" @click="copyToOtherFoot('right')">
                    <b-icon icon="content-copy" />
                  </a>
                </b-tooltip>
              </div>
              <div class="column is-11">
                <h3 class="subtitle green">
                  {{ $translate('left_foot') | uppercase }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column" style="position: relative; height: 50px">
        <div class="columns">
          <div class="column is-12">
            <div class="columns is-mobile">
              <div class="column is-11">
                <h3 class="subtitle green has-text-right">
                  {{ $translate('right_foot') | uppercase }}
                </h3>
              </div>
              <div class="column is-1">
                <b-tooltip
                  type="is-dark"
                  position="is-left"
                  :label="$translate('copy_sx_in_dx') | capitalize"
                  multilined
                >
                  <a class="button is-primary" :disabled="disabledbool" @click="copyToOtherFoot('left')">
                    <b-icon icon="content-copy" />
                  </a>
                </b-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column is-narrow">
        <table class="bordered-table dynamic">
          <thead>
            <tr>
              <th></th>
              <th>{{ $translate('addOn') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="addOn in $addOns[module]" :key="addOn.name">
              <td>
                <b-field>
                  <b-select
                    v-model="values.left[addOn.name]"
                    :disabled="disabledbool"
                    @input="newVal => onChange(newVal, 'left', addOn.name)"
                  >
                    <option v-for="thickness in addOn.range" :key="`${addOn.name}-${thickness}`" :value="thickness">{{
                      thickness !== 0 ? thickness + ' mm' : $translate('none')
                    }}</option>
                  </b-select>
                </b-field>
              </td>
              <td class="header">
                <strong>{{ $translate(addOn.name) | capitalize }}</strong>
              </td>
              <td>
                <b-field>
                  <b-select
                    v-model="values.right[addOn.name]"
                    :disabled="disabledbool"
                    @input="newVal => onChange(newVal, 'right', addOn.name)"
                  >
                    <option v-for="thickness in addOn.range" :key="`${addOn.name}-${thickness}`" :value="thickness">{{
                      thickness !== 0 ? thickness + ' mm' : $translate('none')
                    }}</option>
                  </b-select>
                </b-field>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeasurementsAddOn',
  props: ['measures', 'disabledbool', 'module'],
  data() {
    return {
      selectedThickness: {},
      values: {
        left: {
          add_instep: 0,
          add_fifthMeta: 0,
          add_toe: 0,
          add_firstMeta: 0,
          add_extraTotal: 0,
          add_extraHeel: 0,
          add_fingers: 0,
        },
        right: {
          add_instep: 0,
          add_fifthMeta: 0,
          add_toe: 0,
          add_firstMeta: 0,
          add_extraTotal: 0,
          add_extraHeel: 0,
          add_fingers: 0,
        },
      },
    }
  },
  watch: {
    measures: {
      handler(newMeasures) {
        this.values = { ...this.values, ...newMeasures }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onChange(newValue, foot, header) {
      this.values[foot] = { ...this.values[foot], [header]: newValue }
      this.$emit('update', this.values)
    },
    copyToOtherFoot(foot) {
      if (foot === 'left') {
        this.values.right = { ...this.values.left }
      }
      if (foot === 'right') {
        this.values.left = { ...this.values.right }
      }
      this.$emit('update', this.values)
    },
  },
}
</script>
<style scoped></style>
